import React from 'react';
import { Typography, Chip } from '@mui/material';
import { ContractView } from '../../../../../../../services/ContractService/types/contractTypes';

/**
 * Calculation type template with color-coded chips
 */
export const CalcTypeTemplate: React.FC<{ calcType: string | null | undefined }> = ({ calcType }) => {
  const calcTypeColors: Record<string, { backgroundColor: string; color: string }> = {
    DRG: { backgroundColor: '#fee2e2', color: '#dc2626' },
    CPT: { backgroundColor: '#fef3c7', color: '#d97706' },
    'Per Diem': { backgroundColor: '#dcfce7', color: '#16a34a' },
    'Case Rate': { backgroundColor: '#dbeafe', color: '#2563eb' },
  };

  const calcColor = calcTypeColors[calcType as string] || {
    backgroundColor: '#f3f4f6',
    color: '#374151',
  };

  return calcType ? (
    <Chip label={calcType} size="small" sx={calcColor} />
  ) : (
    <Typography variant="body2" sx={{ color: '#94a3b8' }}>
      -
    </Typography>
  );
};

// Template function for grid column
export const calcTypeTemplate = (rowData: ContractView) => (
  <CalcTypeTemplate calcType={rowData.calcType} />
);

export default CalcTypeTemplate;
